import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=055712bb&"
import script from "./LocaleSelect.vue?vue&type=script&lang=ts&"
export * from "./LocaleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports